export const regions = [
    {
        name: "India",
        slug: "india",
        states: [
            {
                name: "Kerala",
                slug: "kerala",
                districts: [
                    {name: "Alappuzha", slug: "alappuzha"},
                    {name: "Ernakulam", slug: "ernakulam"},
                    {name: "Idukki", slug: "idukki"},
                    {name: "Kannur", slug: "kannur"},
                    {name: "Kasaragod", slug: "kasaragod"},
                    {name: "Kollam", slug: "kollam"},
                    {name: "Kottayam", slug: "kottayam"},
                    {name: "Kozhikode", slug: "kozhikode"},
                    {name: "Malappuram", slug: "malappuram"},
                    {name: "Palakkad", slug: "palakkad"},
                    {name: "Pathanamthitta", slug: "pathanamthitta"},
                    {name: "Thiruvananthapuram", slug: "thiruvananthapuram"},
                    {name: "Thrissur", slug: "thrissur"},
                    {name: "Wayanad", slug: "wayanad"},
                ],
            },
            {
                name: "Tamil Nadu",
                slug: "tamil-nadu",
                districts: [
                    {name: "Chennai", slug: "chennai"},
                    {name: "Coimbatore", slug: "coimbatore"},
                    {name: "Madurai", slug: "madurai"},
                    {name: "Tiruchirappalli", slug: "tiruchirappalli"},
                    {name: "Salem", slug: "salem"},
                    {name: "Tirunelveli", slug: "tirunelveli"},
                    {name: "Vellore", slug: "vellore"},
                    {name: "Erode", slug: "erode"},
                    {name: "Thoothukudi", slug: "thoothukudi"},
                    {name: "Nagercoil", slug: "nagercoil"},
                    {name: "Dindigul", slug: "dindigul"},
                    {name: "Karur", slug: "karur"},
                    {name: "Kanchipuram", slug: "kanchipuram"},
                    {name: "Krishnagiri", slug: "krishnagiri"},
                    {name: "Namakkal", slug: "namakkal"},
                    {name: "Ramanathapuram", slug: "ramanathapuram"},
                    {name: "Cuddalore", slug: "cuddalore"},
                    {name: "Dharmapuri", slug: "dharmapuri"},
                    {name: "Pudukkottai", slug: "pudukkottai"},
                    {name: "Sivaganga", slug: "sivaganga"},
                ],
            },
            {
                name: "Karnataka",
                slug: "karnataka",
                districts: [
                    {name: "Bengaluru", slug: "bengaluru"},
                    {name: "Mysuru", slug: "mysuru"},
                    {name: "Hubballi", slug: "hubballi"},
                    {name: "Mangaluru", slug: "mangaluru"},
                    {name: "Belagavi", slug: "belagavi"},
                    {name: "Ballari", slug: "ballari"},
                    {name: "Kalaburagi", slug: "kalaburagi"},
                    {name: "Shimoga", slug: "shimoga"},
                    {name: "Tumakuru", slug: "tumakuru"},
                    {name: "Davangere", slug: "davangere"},
                    {name: "Chitradurga", slug: "chitradurga"},
                    {name: "Chikkamagaluru", slug: "chikkamagaluru"},
                    {name: "Raichur", slug: "raichur"},
                    {name: "Bagalkot", slug: "bagalkot"},
                    {name: "Dakshina Kannada", slug: "dakshina-kannada"},
                    {name: "Hassan", slug: "hassan"},
                    {name: "Udupi", slug: "udupi"},
                    {name: "Kolar", slug: "kolar"},
                    {name: "Kodagu", slug: "kodagu"},
                    {name: "Chamarajanagar", slug: "chamarajanagar"},
                ],
            },
            {
                name: "Andhra Pradesh",
                slug: "andhra-pradesh",
                districts: [
                    {name: "Anantapur", slug: "anantapur"},
                    {name: "Chittoor", slug: "chittoor"},
                    {name: "East Godavari", slug: "east-godavari"},
                    {name: "Guntur", slug: "guntur"},
                    {name: "Kadapa", slug: "kadapa"},
                    {name: "Krishna", slug: "krishna"},
                    {name: "Kurnool", slug: "kurnool"},
                    {name: "Prakasam", slug: "prakasam"},
                    {name: "Srikakulam", slug: "srikakulam"},
                    {name: "Visakhapatnam", slug: "visakhapatnam"},
                    {name: "Vizianagaram", slug: "vizianagaram"},
                    {name: "West Godavari", slug: "west-godavari"},
                    {name: "Annamayya", slug: "annamayya"},
                    {name: "Bapatla", slug: "bapatla"},
                    {name: "Sri Potti Sriramulu Nellore", slug: "sri-potti-sriramulu-nellore"},
                ],
            },
            {
                name: "Telangana",
                slug: "telangana",
                districts: [
                    {name: "Adilabad", slug: "adilabad"},
                    {name: "Hyderabad", slug: "hyderabad"},
                    {name: "Karimnagar", slug: "karimnagar"},
                    {name: "Khammam", slug: "khammam"},
                    {name: "Mahabubnagar", slug: "mahabubnagar"},
                    {name: "Medak", slug: "medak"},
                    {name: "Nalgonda", slug: "nalgonda"},
                    {name: "Nizamabad", slug: "nizamabad"},
                    {name: "Warangal", slug: "warangal"},
                    {name: "Rangareddy", slug: "rangareddy"},
                    {name: "Khammam", slug: "khammam"},
                    {name: "Jagitial", slug: "jagitial"},
                    {name: "Jangaon", slug: "jangaon"},
                    {name: "Mahabubabad", slug: "mahabubabad"},
                    {name: "Sangareddy", slug: "sangareddy"},
                ],
            },
            {
                name: "Goa",
                slug: "goa",
                districts: [
                    {name: "North Goa", slug: "north-goa"},
                    {name: "South Goa", slug: "south-goa"},
                ],
            },
            {
                name: "Maharashtra",
                slug: "maharashtra",
                districts: [
                    {name: "Ahmednagar", slug: "ahmednagar"},
                    {name: "Akola", slug: "akola"},
                    {name: "Amravati", slug: "amravati"},
                    {name: "Aurangabad", slug: "aurangabad"},
                    {name: "Beed", slug: "beed"},
                    {name: "Bhandara", slug: "bhandara"},
                    {name: "Buldhana", slug: "buldhana"},
                    {name: "Chandrapur", slug: "chandrapur"},
                    {name: "Dhule", slug: "dhule"},
                    {name: "Gadchiroli", slug: "gadchiroli"},
                    {name: "Gondia", slug: "gondia"},
                    {name: "Hingoli", slug: "hingoli"},
                    {name: "Jalna", slug: "jalna"},
                    {name: "Kolhapur", slug: "kolhapur"},
                    {name: "Latur", slug: "latur"},
                    {name: "Mumbai City", slug: "mumbai-city"},
                    {name: "Mumbai Suburban", slug: "mumbai-suburban"},
                    {name: "Nagpur", slug: "nagpur"},
                    {name: "Nanded", slug: "nanded"},
                    {name: "Nandurbar", slug: "nandurbar"},
                    {name: "Nasik", slug: "nasik"},
                    {name: "Osmanabad", slug: "osmanabad"},
                    {name: "Palghar", slug: "palghar"},
                    {name: "Parbhani", slug: "parbhani"},
                    {name: "Pune", slug: "pune"},
                    {name: "Raigad", slug: "raigad"},
                    {name: "Ratnagiri", slug: "ratnagiri"},
                    {name: "Sangli", slug: "sangli"},
                    {name: "Satara", slug: "satara"},
                    {name: "Sindhudurg", slug: "sindhudurg"},
                    {name: "Solapur", slug: "solapur"},
                    {name: "Thane", slug: "thane"},
                    {name: "Wardha", slug: "wardha"},
                    {name: "Washim", slug: "washim"},
                    {name: "Yavatmal", slug: "yavatmal"},
                ],
            },
            {
                name: "Chhattisgarh",
                slug: "chhattisgarh",
                districts: [
                    {name: "Balod", slug: "balod"},
                    {name: "Baloda Bazar", slug: "baloda-bazar"},
                    {name: "Balrampur", slug: "balrampur"},
                    {name: "Bastar", slug: "bastar"},
                    {name: "Bijapur", slug: "bijapur"},
                    {name: "Bilaspur", slug: "bilaspur"},
                    {name: "Dantewada", slug: "dantewada"},
                    {name: "Dhamtari", slug: "dhamtari"},
                    {name: "Durg", slug: "durg"},
                    {name: "Gariaband", slug: "gariaband"},
                    {name: "Janjgir-Champa", slug: "janjgir-champa"},
                    {name: "Jashpur", slug: "jashpur"},
                    {name: "Kabirdham", slug: "kabirdham"},
                    {name: "Kanker", slug: "kanker"},
                    {name: "Kondagaon", slug: "kondagaon"},
                    {name: "Korba", slug: "korba"},
                    {name: "Koriya", slug: "koriya"},
                    {name: "Mahasamund", slug: "mahasamund"},
                    {name: "Mungeli", slug: "mungeli"},
                    {name: "Narayanpur", slug: "narayanpur"},
                    {name: "Raigarh", slug: "raigarh"},
                    {name: "Raipur", slug: "raipur"},
                    {name: "Rajnandgaon", slug: "rajnandgaon"},
                    {name: "Sukma", slug: "sukma"},
                    {name: "Surajpur", slug: "surajpur"},
                    {name: "Surguja", slug: "surguja"},
                ],
            },
            {
                name: "Odisha",
                slug: "odisha",
                districts: [
                    {name: "Angul", slug: "angul"},
                    {name: "Bargarh", slug: "bargarh"},
                    {name: "Bhadrak", slug: "bhadrak"},
                    {name: "Balangir", slug: "balangir"},
                    {name: "Balasore", slug: "balasore"},
                    {name: "Cuttack", slug: "cuttack"},
                    {name: "Deogarh", slug: "deogarh"},
                    {name: "Dhenkanal", slug: "dhenkanal"},
                    {name: "Ganjam", slug: "ganjam"},
                    {name: "Gajapati", slug: "gajapati"},
                    {name: "Jagatsinghpur", slug: "jagatsinghpur"},
                    {name: "Jajpur", slug: "jajpur"},
                    {name: "Kalahandi", slug: "kalahandi"},
                    {name: "Kandhamal", slug: "kandhamal"},
                    {name: "Kendrapara", slug: "kendrapara"},
                    {name: "Kendujhar", slug: "kendujhar"},
                    {name: "Khordha", slug: "khordha"},
                    {name: "Koraput", slug: "koraput"},
                    {name: "Malkangiri", slug: "malkangiri"},
                    {name: "Mayurbhanj", slug: "mayurbhanj"},
                    {name: "Nabarangpur", slug: "nabarangpur"},
                    {name: "Nayagarh", slug: "nayagarh"},
                    {name: "Puri", slug: "puri"},
                    {name: "Rayagada", slug: "rayagada"},
                    {name: "Sambalpur", slug: "sambalpur"},
                    {name: "Sonepur", slug: "sonepur"},
                    {name: "Subarnapur", slug: "subarnapur"},
                    {name: "Jagatsinghpur", slug: "jagatsinghpur"},
                ],
            },
            {
                name: "Gujarat",
                slug: "gujarat",
                districts: [
                    {name: "Ahmedabad", slug: "ahmedabad"},
                    {name: "Amreli", slug: "amreli"},
                    {name: "Anand", slug: "anand"},
                    {name: "Aravalli", slug: "aravalli"},
                    {name: "Banaskantha", slug: "banaskantha"},
                    {name: "Bharuch", slug: "bharuch"},
                    {name: "Bhavnagar", slug: "bhavnagar"},
                    {name: "Botad", slug: "botad"},
                    {name: "Chhota Udepur", slug: "chhota-udepur"},
                    {name: "Dahod", slug: "dahod"},
                    {name: "Dang", slug: "dang"},
                    {name: "Gandhinagar", slug: "gandhinagar"},
                    {name: "Gir Somnath", slug: "gir-somnath"},
                    {name: "Jamnagar", slug: "jamnagar"},
                    {name: "Junagadh", slug: "junagadh"},
                    {name: "Kutch", slug: "kutch"},
                    {name: "Mehsana", slug: "mehsana"},
                    {name: "Morbi", slug: "morbi"},
                    {name: "Narmada", slug: "narmada"},
                    {name: "Navsari", slug: "navsari"},
                    {name: "Panchmahal", slug: "panchmahal"},
                    {name: "Patan", slug: "patan"},
                    {name: "Porbandar", slug: "porbandar"},
                    {name: "Rajkot", slug: "rajkot"},
                    {name: "Sabarkantha", slug: "sabarkantha"},
                    {name: "Surat", slug: "surat"},
                    {name: "Surendranagar", slug: "surendranagar"},
                    {name: "Tapi", slug: "tapi"},
                    {name: "Vadodara", slug: "vadodara"},
                    {name: "Valsad", slug: "valsad"},
                ],
            },
            {
                name: "Madhya Pradesh",
                slug: "madhya-pradesh",
                districts: [
                    {name: "Alirajpur", slug: "alirajpur"},
                    {name: "Anuppur", slug: "anuppur"},
                    {name: "Ashoknagar", slug: "ashoknagar"},
                    {name: "Balaghat", slug: "balaghat"},
                    {name: "Barwani", slug: "barwani"},
                    {name: "Betul", slug: "betul"},
                    {name: "Bhopal", slug: "bhopal"},
                    {name: "Burhanpur", slug: "burhanpur"},
                    {name: "Chhatarpur", slug: "chhatarpur"},
                    {name: "Chhindwara", slug: "chhindwara"},
                    {name: "Damoh", slug: "damoh"},
                    {name: "Datia", slug: "datia"},
                    {name: "Dewas", slug: "dewas"},
                    {name: "Dhar", slug: "dhar"},
                    {name: "Dindori", slug: "dindori"},
                    {name: "Guna", slug: "guna"},
                    {name: "Gwalior", slug: "gwalior"},
                    {name: "Harda", slug: "harda"},
                    {name: "Hoshangabad", slug: "hoshangabad"},
                    {name: "Indore", slug: "indore"},
                    {name: "Jabalpur", slug: "jabalpur"},
                    {name: "Jhabua", slug: "jhabua"},
                    {name: "Katni", slug: "katni"},
                    {name: "Khandwa", slug: "khandwa"},
                    {name: "Khargone", slug: "khargone"},
                    {name: "Mandla", slug: "mandla"},
                    {name: "Mandsaur", slug: "mandsaur"},
                    {name: "Morena", slug: "morena"},
                    {name: "Narsinghpur", slug: "narsinghpur"},
                    {name: "Neemuch", slug: "neemuch"},
                    {name: "Pachmarhi", slug: "pachmarhi"},
                    {name: "Panna", slug: "panna"},
                    {name: "Raisen", slug: "raisen"},
                    {name: "Rajgarh", slug: "rajgarh"},
                    {name: "Ratlam", slug: "ratlam"},
                    {name: "Rewa", slug: "rewa"},
                    {name: "Sagar", slug: "sagar"},
                    {name: "Satna", slug: "satna"},
                    {name: "Sehore", slug: "sehore"},
                    {name: "Seoni", slug: "seoni"},
                    {name: "Shahdol", slug: "shahdol"},
                    {name: "Shajapur", slug: "shajapur"},
                    {name: "Sheopur", slug: "sheopur"},
                    {name: "Shivpuri", slug: "shivpuri"},
                    {name: "Sidhi", slug: "sidhi"},
                    {name: "Singrauli", slug: "singrauli"},
                    {name: "Tikamgarh", slug: "tikamgarh"},
                    {name: "Ujjain", slug: "ujjain"},
                    {name: "Umaria", slug: "umaria"},
                    {name: "Vidisha", slug: "vidisha"},
                ],
            },
            {
                name: "Rajasthan",
                slug: "rajasthan",
                districts: [
                    {name: "Ajmer", slug: "ajmer"},
                    {name: "Alwar", slug: "alwar"},
                    {name: "Banswara", slug: "banswara"},
                    {name: "Baran", slug: "baran"},
                    {name: "Barmer", slug: "barmer"},
                    {name: "Bhilwara", slug: "bhilwara"},
                    {name: "Bikaner", slug: "bikaner"},
                    {name: "Bundi", slug: "bundi"},
                    {name: "Chittorgarh", slug: "chittorgarh"},
                    {name: "Churu", slug: "churu"},
                    {name: "Dausa", slug: "dausa"},
                    {name: "Dholpur", slug: "dholpur"},
                    {name: "Dungarpur", slug: "dungarpur"},
                    {name: "Ganganagar", slug: "ganganagar"},
                    {name: "Hanumangarh", slug: "hanumangarh"},
                    {name: "Jaipur", slug: "jaipur"},
                    {name: "Jaisalmer", slug: "jaisalmer"},
                    {name: "Jalore", slug: "jalore"},
                    {name: "Jhalawar", slug: "jhalawar"},
                    {name: "Jhunjhunu", slug: "jhunjhunu"},
                    {name: "Jodhpur", slug: "jodhpur"},
                    {name: "Karauli", slug: "karauli"},
                    {name: "Kota", slug: "kota"},
                    {name: "Nagaur", slug: "nagaur"},
                    {name: "Pali", slug: "pali"},
                    {name: "Pratapgarh", slug: "pratapgarh"},
                    {name: "Rajsamand", slug: "rajsamand"},
                    {name: "Sawai Madhopur", slug: "sawai-madhopur"},
                    {name: "Sikar", slug: "sikar"},
                    {name: "Sirohi", slug: "sirohi"},
                    {name: "Tonk", slug: "tonk"},
                    {name: "Udaipur", slug: "udaipur"},
                ],
            },
            {
                name: "Uttar Pradesh",
                slug: "uttar-pradesh",
                districts: [
                    {name: "Agra", slug: "agra"},
                    {name: "Aligarh", slug: "aligarh"},
                    {name: "Allahabad", slug: "allahabad"},
                    {name: "Ambedkar Nagar", slug: "ambedkar-nagar"},
                    {name: "Amethi", slug: "amethi"},
                    {name: "Amroha", slug: "amroha"},
                    {name: "Auraiya", slug: "auraiya"},
                    {name: "Azamgarh", slug: "azamgarh"},
                    {name: "Baghpat", slug: "baghpat"},
                    {name: "Bahraich", slug: "bahraich"},
                    {name: "Ballia", slug: "ballia"},
                    {name: "Balrampur", slug: "balrampur"},
                    {name: "Banda", slug: "banda"},
                    {name: "Barabanki", slug: "barabanki"},
                    {name: "Bareilly", slug: "bareilly"},
                    {name: "Basti", slug: "basti"},
                    {name: "Bhadohi", slug: "bhadohi"},
                    {name: "Bijnor", slug: "bijnor"},
                    {name: "Budaun", slug: "budaun"},
                    {name: "Bulandshahr", slug: "bulandshahr"},
                    {name: "Chandauli", slug: "chandauli"},
                    {name: "Chitrakoot", slug: "chitrakoot"},
                    {name: "Deoria", slug: "deoria"},
                    {name: "Etah", slug: "etah"},
                    {name: "Etawah", slug: "etawah"},
                    {name: "Faizabad", slug: "faizabad"},
                    {name: "Farrukhabad", slug: "farrukhabad"},
                    {name: "Fatehpur", slug: "fatehpur"},
                    {name: "Firozabad", slug: "firozabad"},
                    {name: "Gautam Buddha Nagar", slug: "gautam-buddha-nagar"},
                    {name: "Ghaziabad", slug: "ghaziabad"},
                    {name: "Ghazipur", slug: "ghazipur"},
                    {name: "Gonda", slug: "gonda"},
                    {name: "Gorakhpur", slug: "gorakhpur"},
                    {name: "Hamirpur", slug: "hamirpur"},
                    {name: "Hapur", slug: "hapur"},
                    {name: "Hardoi", slug: "hardoi"},
                    {name: "Hathras", slug: "hathras"},
                    {name: "Jalaun", slug: "jalaun"},
                    {name: "Jaunpur", slug: "jaunpur"},
                    {name: "Jhansi", slug: "jhansi"},
                    {name: "Kannauj", slug: "kannauj"},
                    {name: "Kanpur Dehat", slug: "kanpur-dehat"},
                    {name: "Kanpur Nagar", slug: "kanpur-nagar"},
                    {name: "Kushinagar", slug: "kushinagar"},
                    {name: "Lalitpur", slug: "lalitpur"},
                    {name: "Lucknow", slug: "lucknow"},
                    {name: "Maharajganj", slug: "maharajganj"},
                    {name: "Mahoba", slug: "mahoba"},
                    {name: "Mainpuri", slug: "mainpuri"},
                    {name: "Mathura", slug: "mathura"},
                    {name: "Meerut", slug: "meerut"},
                    {name: "Mirzapur", slug: "mirzapur"},
                    {name: "Moradabad", slug: "moradabad"},
                    {name: "Muzaffarnagar", slug: "muzaffarnagar"},
                    {name: "Pilibhit", slug: "pilibhit"},
                    {name: "Pratapgarh", slug: "pratapgarh"},
                    {name: "Raebareli", slug: "raebareli"},
                    {name: "Rampur", slug: "rampur"},
                    {name: "Saharanpur", slug: "saharanpur"},
                    {name: "Sambhal", slug: "sambhal"},
                    {name: "Sant Kabir Nagar", slug: "sant-kabir-nagar"},
                    {name: "Shahjahanpur", slug: "shahjahanpur"},
                    {name: "Shamli", slug: "shamli"},
                    {name: "Shravasti", slug: "shravasti"},
                    {name: "Siddharthnagar", slug: "siddharthnagar"},
                    {name: "Sitapur", slug: "sitapur"},
                    {name: "Sonbhadra", slug: "sonbhadra"},
                    {name: "Sultanpur", slug: "sultanpur"},
                    {name: "Unnao", slug: "unnao"},
                    {name: "Varanasi", slug: "varanasi"},
                ],
            },

            {
                name: "Bihar",
                slug: "bihar",
                districts: [
                    {name: "Araria", slug: "araria"},
                    {name: "Arwal", slug: "arwal"},
                    {name: "Aurangabad", slug: "aurangabad"},
                    {name: "Banka", slug: "banka"},
                    {name: "Begusarai", slug: "begusarai"},
                    {name: "Bhagalpur", slug: "bhagalpur"},
                    {name: "Bhojpur", slug: "bhojpur"},
                    {name: "Buxar", slug: "buxar"},
                    {name: "Darbhanga", slug: "darbhanga"},
                    {name: "East Champaran", slug: "east-champaran"},
                    {name: "Gaya", slug: "gaya"},
                    {name: "Gopalganj", slug: "gopalganj"},
                    {name: "Jamui", slug: "jamui"},
                    {name: "Jehanabad", slug: "jehanabad"},
                    {name: "Kaimur", slug: "kaimur"},
                    {name: "Katihar", slug: "katihar"},
                    {name: "Khagaria", slug: "khagaria"},
                    {name: "Kishanganj", slug: "kishanganj"},
                    {name: "Lakhisarai", slug: "lakhisarai"},
                    {name: "Madhepura", slug: "madhepura"},
                    {name: "Madhubani", slug: "madhubani"},
                    {name: "Munger", slug: "munger"},
                    {name: "Muzaffarpur", slug: "muzaffarpur"},
                    {name: "Nalanda", slug: "nalanda"},
                    {name: "Nawada", slug: "nawada"},
                    {name: "Patna", slug: "patna"},
                    {name: "Purnia", slug: "purnia"},
                    {name: "Rohtas", slug: "rohtas"},
                    {name: "Saharsa", slug: "saharsa"},
                    {name: "Samastipur", slug: "samastipur"},
                    {name: "Saran", slug: "saran"},
                    {name: "Sheikhpura", slug: "sheikhpura"},
                    {name: "Sheohar", slug: "sheohar"},
                    {name: "Sitamarhi", slug: "sitamarhi"},
                    {name: "Supaul", slug: "supaul"},
                    {name: "Vaishali", slug: "vaishali"},
                    {name: "West Champaran", slug: "west-champaran"},
                ],
            },
            {
                name: "Jharkhand",
                slug: "jharkhand",
                districts: [
                    {name: "Bokaro", slug: "bokaro"},
                    {name: "Chatra", slug: "chatra"},
                    {name: "Deoghar", slug: "deoghar"},
                    {name: "Dhanbad", slug: "dhanbad"},
                    {name: "Dumka", slug: "dumka"},
                    {name: "East Singhbhum", slug: "east-singhbhum"},
                    {name: "Garhwa", slug: "garhwa"},
                    {name: "Giridih", slug: "giridih"},
                    {name: "Godda", slug: "godda"},
                    {name: "Gumla", slug: "gumla"},
                    {name: "Hazaribagh", slug: "hazaribagh"},
                    {name: "Jamtara", slug: "jamtara"},
                    {name: "Khunti", slug: "khunti"},
                    {name: "Koderma", slug: "koderma"},
                    {name: "Latehar", slug: "latehar"},
                    {name: "Lohardaga", slug: "lohardaga"},
                    {name: "Pakur", slug: "pakur"},
                    {name: "Palamu", slug: "palamu"},
                    {name: "Ramgarh", slug: "ramgarh"},
                    {name: "Ranchi", slug: "ranchi"},
                    {name: "Sahibganj", slug: "sahibganj"},
                    {name: "Saraikela Kharsawan", slug: "saraikela-kharsawan"},
                    {name: "Simdega", slug: "simdega"},
                    {name: "West Singhbhum", slug: "west-singhbhum"},
                ],
            },
            {
                name: "West Bengal",
                slug: "west-bengal",
                districts: [
                    {name: "Alipurduar", slug: "alipurduar"},
                    {name: "Bankura", slug: "bankura"},
                    {name: "Birbhum", slug: "birbhum"},
                    {name: "Burdwan", slug: "burdwan"},
                    {name: "Cooch Behar", slug: "cooch-behar"},
                    {name: "Dakshin Dinajpur", slug: "dakshin-dinajpur"},
                    {name: "Darjeeling", slug: "darjeeling"},
                    {name: "Hooghly", slug: "hooghly"},
                    {name: "Howrah", slug: "howrah"},
                    {name: "Jalpaiguri", slug: "jalpaiguri"},
                    {name: "Jhargram", slug: "jhargram"},
                    {name: "Kolkata", slug: "kolkata"},
                    {name: "Malda", slug: "malda"},
                    {name: "Murshidabad", slug: "murshidabad"},
                    {name: "Mursidabad", slug: "mursidabad"},
                    {name: "Nadia", slug: "nadia"},
                    {name: "North 24 Parganas", slug: "north-24-parganas"},
                    {name: "Purba Bardhaman", slug: "purba-bardhaman"},
                    {name: "Purulia", slug: "purulia"},
                    {name: "South 24 Parganas", slug: "south-24-parganas"},
                    {name: "Paschim Bardhaman", slug: "paschim-bardhaman"},
                    {name: "Paschim Medinipur", slug: "paschim-medinipur"},
                    {name: "Purba Medinipur", slug: "purba-medinipur"},
                    {name: "South Dinajpur", slug: "south-dinajpur"},
                    {name: "Uttar Dinajpur", slug: "uttar-dinajpur"},
                ],
            },
            {
                name: "Sikkim",
                slug: "sikkim",
                districts: [
                    {name: "East Sikkim", slug: "east-sikkim"},
                    {name: "North Sikkim", slug: "north-sikkim"},
                    {name: "South Sikkim", slug: "south-sikkim"},
                    {name: "West Sikkim", slug: "west-sikkim"},
                ],
            },
            {
                name: "Assam",
                slug: "assam",
                districts: [
                    {name: "Baksa", slug: "baksa"},
                    {name: "Barpeta", slug: "barpeta"},
                    {name: "Bongaigaon", slug: "bongaigaon"},
                    {name: "Cachar", slug: "cachar"},
                    {name: "Charaideo", slug: "charaideo"},
                    {name: "Chirang", slug: "chirang"},
                    {name: "Darrang", slug: "darrang"},
                    {name: "Dhemaji", slug: "dhemaji"},
                    {name: "Dibrugarh", slug: "dibrugarh"},
                    {name: "Goalpara", slug: "goalpara"},
                    {name: "Golaghat", slug: "golaghat"},
                    {name: "Hailakandi", slug: "hailakandi"},
                    {name: "Jorhat", slug: "jorhat"},
                    {name: "Kamrup", slug: "kamrup"},
                    {name: "Kamrup Metropolitan", slug: "kamrup-metropolitan"},
                    {name: "Karbi Anglong", slug: "karbi-anglong"},
                    {name: "Karimganj", slug: "karimganj"},
                    {name: "Kokrajhar", slug: "kokrajhar"},
                    {name: "Lakhimpur", slug: "lakhimpur"},
                    {name: "Majuli", slug: "majuli"},
                    {name: "Morigaon", slug: "morigaon"},
                    {name: "Nagaon", slug: "nagaon"},
                    {name: "Nalbari", slug: "nalbari"},
                    {name: "Sivasagar", slug: "sivasagar"},
                    {name: "Sonitpur", slug: "sonitpur"},
                    {name: "Tinsukia", slug: "tinsukia"},
                    {name: "Udalguri", slug: "udalguri"},
                    {name: "West Karbi Anglong", slug: "west-karbi-anglong"},
                ],
            },
            {
                name: "Arunachal Pradesh",
                slug: "arunachal-pradesh",
                districts: [
                    {name: "Anjaw", slug: "anjaw"},
                    {name: "Changlang", slug: "changlang"},
                    {name: "East Kameng", slug: "east-kameng"},
                    {name: "East Siang", slug: "east-siang"},
                    {name: "Kurung Kumey", slug: "kurung-kumey"},
                    {name: "Lohit", slug: "lohit"},
                    {name: "Longding", slug: "longding"},
                    {name: "Lower Dibang Valley", slug: "lower-dibang-valley"},
                    {name: "Lower Subansiri", slug: "lower-subansiri"},
                    {name: "Namsai", slug: "namsai"},
                    {name: "Papum Pare", slug: "papum-pare"},
                    {name: "Tawang", slug: "tawang"},
                    {name: "Tirap", slug: "tirap"},
                    {name: "Upper Dibang Valley", slug: "upper-dibang-valley"},
                    {name: "Upper Siang", slug: "upper-siang"},
                    {name: "Upper Subansiri", slug: "upper-subansiri"},
                    {name: "West Kameng", slug: "west-kameng"},
                    {name: "West Siang", slug: "west-siang"},
                ],
            },
            {
                name: "Nagaland",
                slug: "nagaland",
                districts: [
                    {name: "Dimapur", slug: "dimapur"},
                    {name: "Kiphire", slug: "kiphire"},
                    {name: "Kohima", slug: "kohima"},
                    {name: "Longleng", slug: "longleng"},
                    {name: "Mokokchung", slug: "mokokchung"},
                    {name: "Mon", slug: "mon"},
                    {name: "Peren", slug: "peren"},
                    {name: "Phek", slug: "phek"},
                    {name: "Tuensang", slug: "tuensang"},
                    {name: "Wokha", slug: "wokha"},
                    {name: "Zunheboto", slug: "zunheboto"},
                ],
            },
            {
                name: "Manipur",
                slug: "manipur",
                districts: [
                    {name: "Bishnupur", slug: "bishnupur"},
                    {name: "Chandel", slug: "chandel"},
                    {name: "Churachandpur", slug: "churachandpur"},
                    {name: "Imphal East", slug: "imphal-east"},
                    {name: "Imphal West", slug: "imphal-west"},
                    {name: "Jiribam", slug: "jiribam"},
                    {name: "Kakching", slug: "kakching"},
                    {name: "Kamjong", slug: "kamjong"},
                    {name: "Kangpokpi", slug: "kangpokpi"},
                    {name: "Noney", slug: "noney"},
                    {name: "Senapati", slug: "senapati"},
                    {name: "Tamenglong", slug: "tamenglong"},
                    {name: "Tengnoupal", slug: "tengnoupal"},
                    {name: "Thoubal", slug: "thoubal"},
                    {name: "Ukhrul", slug: "ukhrul"},
                ],
            },
            {
                name: "Mizoram",
                slug: "mizoram",
                districts: [
                    {name: "Aizawl", slug: "aizawl"},
                    {name: "Champhai", slug: "champhai"},
                    {name: "Kolasib", slug: "kolasib"},
                    {name: "Lawngtlai", slug: "lawngtlai"},
                    {name: "Lunglei", slug: "lunglei"},
                    {name: "Mamit", slug: "mamit"},
                    {name: "Serchhip", slug: "serchhip"},
                    {name: "Siaha", slug: "siaha"},
                    {name: "Sualkuchi", slug: "sualkuchi"},
                ],
            },
            {
                name: "Tripura",
                slug: "tripura",
                districts: [
                    {name: "Dhalai", slug: "dhalai"},
                    {name: "Gomati", slug: "gomati"},
                    {name: "Khowai", slug: "khowai"},
                    {name: "North Tripura", slug: "north-tripura"},
                    {name: "Sepahijala", slug: "sepahijala"},
                    {name: "South Tripura", slug: "south-tripura"},
                    {name: "Unakoti", slug: "unakoti"},
                    {name: "West Tripura", slug: "west-tripura"},
                ],
            },
            {
                name: "Meghalaya",
                slug: "meghalaya",
                districts: [
                    {name: "East Garo Hills", slug: "east-garo-hills"},
                    {name: "East Khasi Hills", slug: "east-khasi-hills"},
                    {name: "Jaintia Hills", slug: "jaintia-hills"},
                    {name: "Ri-Bhoi", slug: "ri-bhoi"},
                    {name: "South Garo Hills", slug: "south-garo-hills"},
                    {name: "South West Garo Hills", slug: "south-west-garo-hills"},
                    {name: "South West Khasi Hills", slug: "south-west-khasi-hills"},
                    {name: "West Garo Hills", slug: "west-garo-hills"},
                    {name: "West Khasi Hills", slug: "west-khasi-hills"},
                ],
            },
            {
                name: "Haryana",
                slug: "haryana",
                districts: [
                    {name: "Ambala", slug: "ambala"},
                    {name: "Bhiwani", slug: "bhiwani"},
                    {name: "Charkhi Dadri", slug: "charkhi-dadri"},
                    {name: "Faridabad", slug: "faridabad"},
                    {name: "Fatehabad", slug: "fatehabad"},
                    {name: "Gurugram", slug: "gurugram"},
                    {name: "Hisar", slug: "hisar"},
                    {name: "Jhajjar", slug: "jhajjar"},
                    {name: "Jind", slug: "jind"},
                    {name: "Kaithal", slug: "kaithal"},
                    {name: "Karnal", slug: "karnal"},
                    {name: "Kurukshetra", slug: "kurukshetra"},
                    {name: "Mahendragarh", slug: "mahendragarh"},
                    {name: "Nuh", slug: "nuh"},
                    {name: "Palwal", slug: "palwal"},
                    {name: "Panchkula", slug: "panchkula"},
                    {name: "Panipat", slug: "panipat"},
                    {name: "Rewari", slug: "rewari"},
                    {name: "Rohtak", slug: "rohtak"},
                    {name: "Sirsa", slug: "sirsa"},
                    {name: "Sonipat", slug: "sonipat"},
                    {name: "Yamunanagar", slug: "yamunanagar"},
                ],
            },
            {
                name: "Punjab",
                slug: "punjab",
                districts: [
                    {name: "Amritsar", slug: "amritsar"},
                    {name: "Barnala", slug: "barnala"},
                    {name: "Bathinda", slug: "bathinda"},
                    {name: "Faridkot", slug: "faridkot"},
                    {name: "Fatehgarh Sahib", slug: "fatehgarh-sahib"},
                    {name: "Firozepur", slug: "firozepur"},
                    {name: "Gurdaspur", slug: "gurdaspur"},
                    {name: "Hoshiarpur", slug: "hoshiarpur"},
                    {name: "Jalandhar", slug: "jalandhar"},
                    {name: "Kapurthala", slug: "kapurthala"},
                    {name: "Ludhiana", slug: "ludhiana"},
                    {name: "Mansa", slug: "mansa"},
                    {name: "Moga", slug: "moga"},
                    {name: "Muktsar", slug: "muktsar"},
                    {name: "Nawanshahr", slug: "nawanshahr"},
                    {name: "Patiala", slug: "patiala"},
                    {name: "Rupnagar", slug: "rupnagar"},
                    {name: "Sahibzada Ajit Singh Nagar", slug: "sahibzada-ajit-singh-nagar"},
                    {name: "Sangrur", slug: "sangrur"},
                    {name: "Shahid Bhagat Singh Nagar", slug: "shahid-bhagat-singh-nagar"},
                    {name: "Tarn Taran", slug: "tarn-taran"},
                ],
            },
            {
                name: "Himachal Pradesh",
                slug: "himachal-pradesh",
                districts: [
                    {name: "Bilaspur", slug: "bilaspur"},
                    {name: "Chamba", slug: "chamba"},
                    {name: "Hamirpur", slug: "hamirpur"},
                    {name: "Kangra", slug: "kangra"},
                    {name: "Kullu", slug: "kullu"},
                    {name: "Mandi", slug: "mandi"},
                    {name: "Solan", slug: "solan"},
                    {name: "Sirmaur", slug: "sirmaur"},
                    {name: "Una", slug: "una"},
                    {name: "Shimla", slug: "shimla"},
                    {name: "Lahaul and Spiti", slug: "lahaul-and-spiti"},
                    {name: "Kinnaur", slug: "kinnaur"},
                ],
            },
            {
                name: "Uttarakhand",
                slug: "uttarakhand",
                districts: [
                    {name: "Almora", slug: "almora"},
                    {name: "Bageshwar", slug: "bageshwar"},
                    {name: "Chamoli", slug: "chamoli"},
                    {name: "Champawat", slug: "champawat"},
                    {name: "Dehradun", slug: "dehradun"},
                    {name: "Haridwar", slug: "haridwar"},
                    {name: "Nainital", slug: "nainital"},
                    {name: "Pauri Garhwal", slug: "pauri-garhwal"},
                    {name: "Pithoragarh", slug: "pithoragarh"},
                    {name: "Rudraprayag", slug: "rudraprayag"},
                    {name: "Tehri Garhwal", slug: "tehri-garhwal"},
                    {name: "Udham Singh Nagar", slug: "udham-singh-nagar"},
                    {name: "Uttarkashi", slug: "uttarkashi"},
                ],
            },
        ],
    },
    {
        name: "United States",
        slug: "united-states",
    },
    {
        name: "United Kingdom",
        slug: "united-kingdom",
    },
    {
        name: "Canada",
        slug: "canada",
    },
    {
        name: "Australia",
        slug: "australia",
    },
    {
        name: "Germany",
        slug: "germany",
    },
    {
        name: "France",
        slug: "france",
    },
    {
        name: "Japan",
        slug: "japan",
    },
    {
        name: "China",
        slug: "china",
    },
    {
        name: "Brazil",
        slug: "brazil",
    },
    {
        name: "South Africa",
        slug: "south-africa",
    },
    {
        name: "Mexico",
        slug: "mexico",
    },
    {
        name: "Italy",
        slug: "italy",
    },
    {
        name: "Russia",
        slug: "russia",
    },
    {
        name: "Spain",
        slug: "spain",
    },
    {
        name: "Sweden",
        slug: "sweden",
    },
    {
        name: "Netherlands",
        slug: "netherlands",
    },
    {
        name: "Belgium",
        slug: "belgium",
    },
    {
        name: "Norway",
        slug: "norway",
    },
    {
        name: "South Korea",
        slug: "south-korea",
    },
    {
        name: "Indonesia",
        slug: "indonesia",
    },
    {
        name: "Saudi Arabia",
        slug: "saudi-arabia",
    },
    {
        name: "Turkey",
        slug: "turkey",
    },
    {
        name: "Argentina",
        slug: "argentina",
    },
    {
        name: "Egypt",
        slug: "egypt",
    },
    {
        name: "Nigeria",
        slug: "nigeria",
    },
    {
        name: "Pakistan",
        slug: "pakistan",
    },
    {
        name: "Bangladesh",
        slug: "bangladesh",
    },
    {
        name: "Vietnam",
        slug: "vietnam",
    },
    {
        name: "Thailand",
        slug: "thailand",
    },
    {
        name: "Malaysia",
        slug: "malaysia",
    },
    {
        name: "Philippines",
        slug: "philippines",
    },
    {
        name: "Singapore",
        slug: "singapore",
    },
    {
        name: "Chile",
        slug: "chile",
    },
    {
        name: "Colombia",
        slug: "colombia",
    },
    {
        name: "Peru",
        slug: "peru",
    },
    {
        name: "Ukraine",
        slug: "ukraine",
    },
    {
        name: "Poland",
        slug: "poland",
    },
    {
        name: "Romania",
        slug: "romania",
    },
    {
        name: "Greece",
        slug: "greece",
    },
    {
        name: "Poland",
        slug: "poland",
    },
    {
        name: "Vietnam",
        slug: "vietnam",
    },
    {
        name: "Malaysia",
        slug: "malaysia",
    },
    {
        name: "Belgium",
        slug: "belgium",
    },
    {
        name: "Switzerland",
        slug: "switzerland",
    },
    {
        name: "Argentina",
        slug: "argentina",
    },
    {
        name: "Chile",
        slug: "chile",
    },
    {
        name: "Portugal",
        slug: "portugal",
    },
    {
        name: "Czech Republic",
        slug: "czech-republic",
    },
    {
        name: "Slovakia",
        slug: "slovakia",
    },
    {
        name: "Hungary",
        slug: "hungary",
    },
    {
        name: "Bulgaria",
        slug: "bulgaria",
    },
    {
        name: "Luxembourg",
        slug: "luxembourg",
    },
    {
        name: "Finland",
        slug: "finland",
    },
    {
        name: "Denmark",
        slug: "denmark",
    },
    {
        name: "Estonia",
        slug: "estonia",
    },
    {
        name: "Latvia",
        slug: "latvia",
    },
    {
        name: "Lithuania",
        slug: "lithuania",
    },
    {
        name: "Iceland",
        slug: "iceland",
    },
    {
        name: "Malta",
        slug: "malta",
    },
    {
        name: "Cyprus",
        slug: "cyprus",
    },
];
